module.exports = __webpack_public_path__ + "static/media/toggle_privacy_icon_open.13da3a4a.svg";